import { get } from 'lodash';
import { connect } from 'react-redux';

import { DoctorNotesView } from './view';
import { APPOINTMENT_DETAILS_ROOT_KEY } from '../../constants';
import {
    enterDoctorNotes as onEnterDoctorNotes,
    trackSelectDoctorNotes,
} from '../../pages/AppointmentDetails/AppointmentDetailsActions';

const mapStateToProps = state => ({
    doctorNotes: get(state[APPOINTMENT_DETAILS_ROOT_KEY], 'doctorNotes'),
});

const mapDispatchToProps = {
    onEnterDoctorNotes,
    trackSelectDoctorNotes,
};

const DoctorNotesContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(DoctorNotesView);

export {
    DoctorNotesView,
    DoctorNotesContainer,
    DoctorNotesContainer as DoctorNotes,
};
